import styled from 'styled-components';
import { THEME_COLORS } from '../utils/theme';

export const PrimaryFont = styled.span`
  font-family: 'Work Sans';
  font-weight: 500;
`;

export const HeaderFont = styled.span`
  font-family: 'Work Sans';
  font-weight: 700;
`;

export const DubHacksFont = styled.span`
  font-family: 'Gemunu Libre';
  font-weight: 800;
`;

export const SectionHeader = styled(HeaderFont)`
  display: block;
  text-align: center;
  margin: 30px 0;
  font-size: max(3.8vw, 50px);
  color: ${props => props.color};
`;

export const SectionBannerPink = styled.div`
  text-align: center;
  background-color: ${THEME_COLORS.lightPink};
  padding: 20px;
`;

export const Data = styled(HeaderFont)`
  display: block;
  font-size: max(3.5rem, 20px);
  padding: 20px 0;
`;

export const DataLabel = styled(HeaderFont)`
  display: block;
  font-size: max(2.5vw, 32px);
  color: ${THEME_COLORS.brandPink};
  height: 100px;
`;
